import { render, staticRenderFns } from "./ThgErrorPage.vue?vue&type=template&id=68e80d3e"
import script from "./ThgErrorPage.vue?vue&type=script&lang=ts"
export * from "./ThgErrorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports